<div class="container">

    <div class="laposte">
        <div>{{year}} &#xA9; LA POSTE</div>
        <div>{{ "footer.all_rights_reserved" | translate}} </div>
    </div>
    <div class="mentions">
        <a (click)="openPopin('personnal')" dataqsi="lienFooter-1">{{ "footer.personal_data.title" | translate}}</a>
        <a (click)="openPopin('cgu')" dataqsi="lienFooter-2">{{ "footer.CGU.title" | translate}}</a>
        <a (click)="openPopin('cookies')" dataqsi="lienFooter-3">{{ "footer.cookies.label" | translate}}</a>
        <a (click)="openPopin('legal')" dataqsi="lienFooter-4">{{ "footer.legal_notices.title" | translate}}</a>
    </div>
    
    <div class="laposte_container">
        <img class="imgPoste" src="assets/images/logo-lapostesolutionbusiness.svg" dataqsi="logoPosteFooter">
    </div>
    
</div>
